import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetPqrTime,
    asyncGetPqrTimeHistorical,
} from '../../../../../services/pqr-times.service';
import { PqrTimeFull } from '../../../../../shared/types/paramPqrTimes';
import { Historical } from '../../../../../shared/types/shared';
import { PQR_TIMES } from '../../../../../routes/paths';

export const usePqrTimesDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idPqrTimes } = useParams();
    const [loading, setLoading] = useState(false);
    const [pqrTimes, setPqrTime] = useState<PqrTimeFull>();
    const [pqrTimesHistorical, setPqrTimesHistorical] =
        useState<Historical[]>();

    useEffect(() => {
        if (Boolean(idPqrTimes?.trim())) {
            setLoading(true);
            asyncGetPqrTime(idPqrTimes?.trim())
                .then((res) => {
                    if (res) setPqrTime(res);
                    else navigate(PQR_TIMES);
                })
                .finally(() => setLoading(false));
        }
    }, [idPqrTimes]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetPqrTimeHistorical(idPqrTimes?.trim())
                .then((resp) => {
                    if (resp) setPqrTimesHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        pqrTimes,
        pqrTimesHistorical,
        showHistorical,
        setShowHistorical,
    };
};
